export class WorkspaceMetricsSettingsAws {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudwatchEnabled",
            "baseName": "cloudwatchEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudwatchMetricNamespace",
            "baseName": "cloudwatchMetricNamespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "ampEnabled",
            "baseName": "ampEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "ampWorkspaceId",
            "baseName": "ampWorkspaceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "ampRemoteWriteUrl",
            "baseName": "ampRemoteWriteUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "ampRegion",
            "baseName": "ampRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "ampCredentialsProfileId",
            "baseName": "ampCredentialsProfileId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceMetricsSettingsAws.attributeTypeMap;
    }
    constructor() {
    }
}
